import { render, staticRenderFns } from "./MyAccountPage.vue?vue&type=template&id=421289e6&scoped=true&"
import script from "./MyAccountPage.vue?vue&type=script&lang=ts&"
export * from "./MyAccountPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountPage.vue?vue&type=style&index=0&id=421289e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421289e6",
  null
  
)

export default component.exports